import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setToken } from '../reducer/AuthSlice';

function ErrorPage() {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(setToken(null));
    }, []);
    
    return <Navigate to="/login" />
}

export default ErrorPage;